/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessIntelligenceBiReportingComponent } from './BusinessIntelligenceBiReportingComponent'
import type { Company } from './Company'
import type { Department } from './Department'
import type { Location } from './Location'
import type { Professional } from './Professional'
import type { Users_Permissions_User } from './Users_Permissions_User'
import type { Vacancy } from './Vacancy'
export type Interaction = {
  id?: number
  professional?: Professional
  type: Interaction.type
  company?: Company
  department?: Department
  location?: Location
  vacancy?: Vacancy
  initiator?: Interaction.initiator
  BusinessIntelligence?: BusinessIntelligenceBiReportingComponent
  reason?: string
  createdAt?: string
  updatedAt?: string
  createdBy?: Users_Permissions_User
  updatedBy?: Users_Permissions_User
}
export namespace Interaction {
  export enum type {
    INTERESTED = 'interested',
    PUBLIC = 'public',
    DENIED = 'denied',
  }
  export enum initiator {
    PROFESSIONAL = 'professional',
    COMPANY = 'company',
    DEPARTMENT = 'department',
    LOCATION = 'location',
    VACANCY = 'vacancy',
  }
}
